/**
 * This is the config file where you can edit information as you want.
 * 
 * There are 3 variable objects which contain all the information.
 * 
 * 1. CommonConfig
 *      This variable contains all the common configuration of your profile
 *      including your name, your social links and the path to draw the signature.
 * 2. ProjectsConfig
 *      This variable contains all the information which will be part of the
 *      projects section. Here you can add your own projects and provide a link for them
 *      and also change the icon as per your liking.
 * 3. CustomSectionsConfig
 *      Now this is the fun part. This variable is an array which can hold any number
 *      of sections. Here you can define any of your custom sections may it be "Work", "Reviews",
 *      "Portfolio" or whatnot. The "content" property supports JSX so you can style or use it
 *      however you like!
 * 
 * So what are you waiting for? GO FOR IT!
 */

import React from 'react';

import { Icons } from './icons';

// CUSTOM ICONS
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import WbIridescentIcon from '@material-ui/icons/WbIridescent';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import ComputerIcon from '@material-ui/icons/Computer';
import InfoIcon from '@material-ui/icons/Info';
import RateReviewIcon from '@material-ui/icons/RateReview';
import Description from '@material-ui/icons/Description';
import PersonIcon from '@material-ui/icons/Person'
import ContactMailIcon from '@material-ui/icons/ContactMail';

// CUSTOM COMPONENTS
import CircleButton from '../components/CircleButton/CircleButton';

// CONFIGURABLE TEXT BEGINS HERE

/** Common config for top section and footer */
const CommonConfig = {
    // Whether to add the free Palestine screen at the start
    addFreePalestine: false,
    // Name that will be displayed at the top
    name: 'Chain Mates',
    // Tagline that will be displayed after the name
    tagline: 'Blockchain Developers',
    // Configuration for signature in the top section
    signature: {
        // Viewbox of the signature SVG
        viewBox: '0 0 400 700',
        // This is the data inside the "d" attribute of the <path> tag in SVG
        signaturePathD: "m129,355c0,0 0.29289,0.29291 1,1c1.41422,1.41422 1.69344,1.4588 3,2c0.92387,0.38269 2.02675,0.22977 3,0c4.35251,-1.0275 6.64886,-6.19577 9,-10c2.62866,-4.25327 5.71413,-7.21167 8,-10c1.7932,-2.18735 4,-4 6,-7c2,-3 5,-7 7,-9c3,-3 6.05664,-5.91754 9,-8c4.0817,-2.88785 7.88152,-5.19028 11,-7c3.868,-2.24469 7.07843,-3.78986 10,-5c2.06586,-0.85571 3.29289,-1.70709 4,-1c0.70711,0.70709 1,1 1,2c0,1 -1,1 -2,1c-1,0 -2,0 -3,0c-1,0 -2,0 -3,0c-1,0 -1.82375,0.48627 -4,1c-0.97325,0.22977 -2.70546,1.34619 -5,3c-1.814,1.30746 -3.52016,2.32367 -5,4c-2.38617,2.703 -4.4588,3.69345 -5,5c-0.76537,1.84775 -2.48625,3.82376 -3,6c-0.68925,2.91974 -0.48625,4.82376 -1,7c-0.68925,2.91974 0,6 0,9c0,4 -0.76537,7.15225 0,9c0.5412,1.30655 1.29869,0.94855 3,2c1.90211,1.17557 2.186,3.69254 4,5c1.14726,0.8269 3,1 5,1c3,0 5.133,0.43048 9,-1c4.19435,-1.55161 7,-2 9,-3c2,-1 4.14935,-1.47427 5,-2c1.90211,-1.17557 1.33749,-3.31 3,-6c1.487,-2.40601 3.2565,-3.797 4,-5c1.66251,-2.69 3.14935,-3.47427 4,-4c1.90211,-1.17557 2.69344,-3.4588 4,-4c1.84776,-0.76538 3,-1 4,-1c1,0 0.5405,1.0535 1,3c0.51375,2.17624 1.49345,4.87857 2,8c0.32036,1.97418 -1,5 -1,6c0,2 -1,4 -1,5c0,2 -0.38269,0.92389 0,0c0.5412,-1.30655 1.71413,-2.21167 4,-5c1.7932,-2.18735 4.61383,-4.297 7,-7c1.47984,-1.67633 3,-4 5,-5c2,-1 2.82375,-2.48627 5,-3c0.97325,-0.22977 1.29289,0.29291 2,1c0.70711,0.70709 0.77025,1.02676 1,2c0.51375,2.17624 1,3 1,5c0,2 0,3 0,4c0,1 0.29289,2.70709 1,2c0.70711,-0.70709 0.41885,-1.41885 2,-3c1.58115,-1.58115 3,-2 5,-3c2,-1 2.85272,-3.1731 4,-4c1.814,-1.30746 3,-2 4,-2c2,0 2.69345,-0.4588 4,-1c0.92389,-0.38269 2,0 3,0c1,0 1.49347,0.87857 2,4c0.48056,2.96127 0.49622,5.90778 1,10c0.36655,2.97751 0.48627,4.82376 1,7c0.22977,0.97324 1,1 2,1c2,0 4.61383,-1.297 7,-4c2.95969,-3.35266 4.7464,-9.16119 8,-14c2.78995,-4.14923 5.40894,-8.77637 8,-14c2.39297,-4.82428 3.49622,-8.90778 4,-13c0.48874,-3.97003 0,-8 0,-12c0,-4 -1.4505,-8.4505 -4,-11c-2.5495,-2.5495 -4.07843,-3.78986 -7,-5c-2.06586,-0.85571 -5.11237,-2.54706 -10,-4c-5.16193,-1.53448 -9.92578,-3.49756 -15,-4c-4.97568,-0.49268 -9.01703,-0.58759 -14,-1c-6.06204,-0.50171 -12.01509,-1.57468 -18,-2c-7.05328,-0.50125 -15,-1 -21,-1c-5,0 -10,0 -14,0c-5,0 -9.96329,1.1604 -14,2c-5.95532,1.23862 -10.03067,0.91232 -13,2c-5.05659,1.85226 -9.0797,2.84796 -13,5c-5.11145,2.80591 -9.3054,4.36166 -14,7c-4.35883,2.44962 -9.40401,5.41156 -14,9c-3.34407,2.61096 -6.51929,5.5582 -9,9c-2.61491,3.62799 -3.75532,7.13202 -6,11c-1.80972,3.11847 -2.19909,7.06458 -3,12c-0.50654,3.12143 -2,7 -2,9c0,3 0,6 0,9c0,3 0.08099,7.10699 1,11c1.02749,4.35251 3.33749,8.31 5,11c1.48699,2.40601 2,5 3,8c1,3 3.91753,6.05664 6,9c2.88786,4.0817 6.74675,7.37134 11,10c3.80423,2.35114 7.81401,4.54895 13,6c5.85777,1.63904 11.96765,2.11688 19,4c7.96558,2.133 14.03746,3.38907 19,4c4.09221,0.50378 9,1 15,1c9,0 16,0 23,0c4,0 8.19891,-1.53238 11,-3c4.42889,-2.32053 6.74675,-4.37134 11,-7c3.80423,-2.35114 8,-4 11,-7c3,-3 6.79489,-6.22021 10,-9c3.77728,-3.276 6.71411,-7.21167 9,-10c2.68979,-3.28101 5,-7 7,-10c2,-3 4.71411,-6.21167 7,-9c0.89661,-1.09366 2,-1 2,-2c0,-1 -2,0 -5,2c-3,2 -4.70547,3.34619 -7,5c-1.814,1.30746 -3.22836,0.85196 -6,2c-1.30655,0.5412 -1.82376,2.48627 -4,3c-0.97324,0.22977 -1,1 1,1c5,0 14.98865,-0.21628 32,-1c29.98486,-1.38144 59.01309,-2.73422 82,-4c15.01056,-0.82657 20,-1 21,-1l0,0",

    },
    email: 'm.fawaadali98@gmail.com',
    // Information for social media accounts
    social: [
        {
            // Name of the social media platform
            name: 'GitHub',
            // Link to your account
            link: 'https://github.com/9inpachi',
            // (Optional) Icon of the social media platform
            // default icon will be used in case of no value
            icon: Icons['github']
        },
        {
            name: 'LinkedIn',
            link: 'https://linkedin.com/in/fawadaliq'
        },
        {
            name: 'Facebook',
            link: 'https://facebook.com/9inpachi'
        },
        {
            name: 'Twitter',
            link: 'https://twitter.com/9inpachi'
        },
        {
            name: 'Email',
            link: 'mailto:m.fawaadali98@gmail.com'
        },
        {
            name: 'CV',
            link: 'https://docs.google.com/document/d/15uVQAhsvKsreOd9Xvh9f-HGMkqpI_7dMuSKmQQvFdCo/view?usp=sharing',
            icon: <Description />
        }
    ],
    vasu: {
        social: [
            {
                name: 'GitHub',
                link: 'https://github.com/Blockspade',
                icon: Icons['github']
            },
            {
                name: 'Twitter',
                link: 'https://x.com/0xBlockspade'
            },
            {
                name: 'Resume',
                link: 'https://drive.google.com/file/d/1dh4eP870dP1Q9tcEw2LJhaEfdpvG1Src/view',
                icon: <Description />
            }
        ]
    },
    varad: {
        social: [
            {
                name: 'GitHub',
                link: 'https://github.com/Hephaestus-V/',
                icon: Icons['github']
            },
            {
                name: 'Twitter',
                link: 'https://x.com/0xvarad'
            },
            {
                name: 'Resume',
                link: 'https://drive.google.com/file/d/1iupUd-oduIeQ_rlq2VFnCAoexWc9bvcs/view',
                icon: <Description />
            }
        ]
    }};

/** Config for the projects section */
const ProjectsConfig = {
    name: 'projects',
    headerIcon: <ComputerIcon />,
    extraClass: '',
    projects: [
        {
            name: 'Uniswap V4 ETF Hook',
            icon: Icons['blockchain'],
            description: 'An innovative automated ETF trading and rebalancing system using Uniswap V4\'s hook functionality. Integrated multiple oracle solutions including Chainlink, Chronicle, and Pyth Network for accurate pricing and randomization. Implemented gas-optimized execution through direct interaction with Uniswap V4 pools. Created a dynamic rebalancing engine that automatically adjusts ETF weights based on market conditions.',
            links: [
                {
                    tooltip: 'See source',
                    link: 'https://github.com/Sen-Com/starfish',
                    icon: Icons['github']
                },
                {
                    tooltip: 'ETHGlobal Bangkok',
                    link: 'https://ethglobal.com/showcase/starfish-65z3p',
                    icon: Icons['link']
                }
            ],
            highlight: 'Won $4000+'
        },
        {
            name: 'HyperHarvest - Cross-Chain Yield Aggregator',
            icon: Icons['blockchain'],
            description: 'An innovative cross-chain yield aggregator maximizing USDC returns across Arbitrum Sepolia and Optimism Sepolia testnets. Features include private yield optimization strategies using Lit Protocol, Chainlink\'s CCIP for cross-chain operations, and Envio for hyper-responsive yield optimization. Dual interface with Web3Auth-enabled web app and XMTP bot in Converse app. It is build for EthOnline hackathon by EthGlobal',
            links: [
                {
                    tooltip: 'See source',
                    link: 'https://github.com/ETHarvest/HyperHarvest',
                    icon: Icons['github']
                },
                {
                    tooltip: 'EthOnline 2024',
                    link: 'https://ethglobal.com/showcase/hyperharvest-ki43o',
                    icon: Icons['link']
                }
            ],
            highlight: 'Won $4500 '
        },
        {
            name: 'Chainflip Referral - Affiliate Program',
            icon: Icons['link'],
            description: 'A decentralized application (dApp) for Chainflip\'s affiliate program. Implements user verification using Worldcoin, features for viewing live campaigns, participating with swap ID and transaction hash, and tracking referral rewards. Enhances user engagement and protocol adoption through a streamlined referral system. Its build for Chainflip Crosschain Summer hackathon on Dorahacks',
            links: [
                {
                    tooltip: 'See source',
                    link: 'https://github.com/VasuGupta153/Chainflip-Referral',
                    icon: Icons['github']
                },
                {
                    tooltip: 'Cross-Chain Summer Hackathon',
                    link: 'https://dorahacks.io/buidl/14467',
                    icon: Icons['link']
                }
            ],
            highlight: 'Won $12000'
        },
        {
            name: 'EasyFarm - Farmer Public Good Funding Platform',
            icon: Icons['agriculture'],
            description: 'A decentralized platform connecting farmers with funding pools and incentivizing sustainable farming practices. Implements World Coin human verification, EAS (Ethereum Attestation Service) for milestone attestation, and IPFS for decentralized storage of farmer data and project information. Its build for Superhack hackathon by EthGlobal',
            links: [
                {
                    tooltip: 'See source',
                    link: 'https://github.com/chrisarevalo11/superhack',
                    icon: Icons['github']
                },
                {
                    tooltip: 'Superhack 2024',
                    link: 'https://ethglobal.com/showcase/easyfarm-wrv44',
                    icon: Icons['link']
                }
            ],
            highlight: 'Won $30'
        }
    ]
};
/** Config for sections */
const CustomSectionsConfig = [
    {
        name: 'about',
        headerIcon: <InfoIcon />,
        extraClass: 'about-section section-reverse',
        content: (
            <div className="about-content">
                <div className="about-header">
                    <h2>{Icons['helpoutline']} Who are ChainMates?</h2>
                </div>
                <div className="about-description">
                    <p>
                        ChainMates is a dynamic duo of blockchain enthusiasts. As final-year B.Tech students, we embarked on our blockchain journey a year ago, driven by a passion for decentralized technologies and their transformative potential.
                    </p>
                    <p>
                        In just four short months since we began participating in hackathons, we've achieved remarkable success. Our innovative projects have earned us victories in several prestigious hackathons, with cumulative winnings exceeding $20,500 USD. This rapid ascent in the blockchain space underscores our dedication, technical prowess, and ability to deliver impactful solutions.
                    </p>
                </div>
                <div className="about-mission">
                    <h3>{Icons['target']} Our Mission</h3>
                    <p>
                        Our mission is to push the boundaries of blockchain technology, creating solutions that address real-world challenges. With each project, we strive to contribute meaningfully to the blockchain ecosystem, leveraging our growing expertise and unbridled enthusiasm.
                    </p>
                </div>
                <div className="about-journey">
                    <h3>{Icons['rocket']} Our Journey</h3>
                    <p>
                        From university classrooms to hackathon podiums, our journey in the blockchain realm has been nothing short of exhilarating. We're committed to continuous learning, innovation, and making a lasting impact in the world of decentralized technologies.
                    </p>
                </div>
                <div className="about-journey">
                    <h3>{Icons['build']} Our Services</h3>
                    <p>
                        At ChainMates, we offer a wide range of blockchain development services tailored to your needs. Whether you require a small component for your project or a full-fledged blockchain-powered website, we've got you covered. Our expertise spans smart contracts, dApp development, cross-chain solutions, and more, ensuring we deliver scalable and efficient solutions for every requirement.
                    </p>
                </div>
                <div className="about-cta">
                    <p>
                        Join us as we continue to explore, create, and revolutionize with blockchain!
                    </p>
                </div>
            </div>
        )
    },
    
    {
        name: 'projects',
        headerIcon: <ComputerIcon />,
        extraClass: '',
        notInMenu: false,
        content: (
            <>
                {ProjectsConfig.projects.map((project, index) => {
                    return (
                        <div key={'project-' + index} className="project-item">
                            <h3 style={{ fontSize: '1.4rem' }}>{project.icon} {project.name}</h3>
                            <p>{project.description}</p>
                            {project.highlight && (
                                <p className="project-highlight">
                                    <span className="highlight-icon">🏆</span> 
                                    {project.highlight}
                                </p>
                            )}
                            <div style={{ textAlign: 'right' }}>
                                {project.links.map((link, linkIndex) => {
                                    return (
                                        <CircleButton key={'project-link-' + index + linkIndex} link={link.link} 
                                            target="_blank" tooltip={link.tooltip} size={1.4}>
                                            {link.icon}
                                        </CircleButton>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </>
        )
    },    // ABOUT SECTION

    {
        name: 'contact',
        headerIcon: <ContactMailIcon />,
        extraClass: 'contact-section',
        content: (
            <div className="contact-content">
                <div className="contact-header">
                    <h2>Get in Touch</h2>
                    <p>Have a project in mind? Let's work together!</p>
                </div>
                <form className="contact-form" action="https://formspree.io/f/mpwzogqg" method="POST">
                    <div className="form-group">
                        <input type="text" name="name" placeholder="Your Name" required />
                    </div>
                    <div className="form-group">
                        <input type="email" name="email" placeholder="Your Email" required />
                    </div>
                    <div className="form-group">
                        <textarea name="message" placeholder="Your Message" rows="5" required></textarea>
                    </div>
                    <button type="submit" className="submit-btn">Send Message</button>
                </form>
            </div>
        )
    }

];

export { CommonConfig, ProjectsConfig, CustomSectionsConfig, Icons };
